<template>
    <div class="ticket-packages-list">
        <ticket-packages-list-item
            v-for="(item, index) in items"
            :key="`${item.type}-${index}`"
            :page="page"
            :id="item.id"
            :hash="item.hash"
            :status="item.status"
            :soldout="item.soldout"
            :status_text="item.status_text"
            :type="item.type"
            :title="item.title"
            :location="item.location"
            :sector="item.sector"
            :rows="item.rows"
            :date="item.date"
            :dayOfWeek="item.dayOfWeek"
            :group="item.group"
            :price="item.price"
            :price_old="item.price_old"
            :ticket_type="item.ticket_type"
            :flag="item.flag"
            :includes="item.includes"
            :included_free="item.included_free"
            :priceType="priceType"
            :ref="`item-${index}`"
            :lang="lang"
            :trans="trans"
            :config="config"
            :html-id="htmlId"
        />
    </div>
</template>

<style lang="scss" scoped>
.ticket-packages-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>

<script>
import TicketPackagesListItem from "./TicketPackagesListItem.vue";

export default {
    components: {
        TicketPackagesListItem
    },
    props: {
        page: {
            type: Object,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        priceType: {
            type: String,
            required: true
        },
        lang: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        htmlId: {
            type: String,
            required: false
        }
    }
};
</script>
